module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av83-f2f39496d2d01f833a2bd0af42d47754.jpg";